import { MessageCircle } from "lucide-react";
import { openWhatsApp } from "../hooks/useAnalytics";
import { SITE_CONFIG } from "../config";

export const WhatsAppButton = () => {
  return (
    <button
      onClick={() => openWhatsApp(SITE_CONFIG.whatsapp.defaultMessage, "floating_button")}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300 group"
      data-testid="whatsapp-button"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white" fill="white" />
      <span className="absolute right-full mr-3 px-3 py-2 bg-white text-gray-800 text-sm rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
        ¿Hablamos?
      </span>
    </button>
  );
};

export default WhatsAppButton;
